export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["GOOGLE"] = "GOOGLE";
    AuthProvider["FACEBOOK"] = "FACEBOOK";
    AuthProvider["GUEST"] = "GUEST";
})(AuthProvider || (AuthProvider = {}));
export var UserRole;
(function (UserRole) {
    UserRole["PLAYER"] = "PLAYER";
    UserRole["HOST"] = "HOST";
    UserRole["ADMIN"] = "ADMIN";
})(UserRole || (UserRole = {}));
export var GameStatus;
(function (GameStatus) {
    GameStatus["PENDING"] = "PENDING";
    GameStatus["ACTIVE"] = "ACTIVE";
    GameStatus["PAUSED"] = "PAUSED";
    GameStatus["COMPLETED"] = "COMPLETED";
    GameStatus["CANCELLED"] = "CANCELLED";
})(GameStatus || (GameStatus = {}));
export var PrizeType;
(function (PrizeType) {
    PrizeType["EARLY_FIVE"] = "EARLY_FIVE";
    PrizeType["TOP_LINE"] = "TOP_LINE";
    PrizeType["MIDDLE_LINE"] = "MIDDLE_LINE";
    PrizeType["BOTTOM_LINE"] = "BOTTOM_LINE";
    PrizeType["FULL_HOUSE"] = "FULL_HOUSE";
    PrizeType["CORNERS"] = "CORNERS";
})(PrizeType || (PrizeType = {}));
export var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["PENDING"] = "PENDING";
    ClaimStatus["VERIFIED"] = "VERIFIED";
    ClaimStatus["REJECTED"] = "REJECTED";
})(ClaimStatus || (ClaimStatus = {}));
//# sourceMappingURL=game.enums.js.map